export default "__VITE_ASSET__DPCUjJS1__"